import {useQuery} from "@tanstack/react-query"
import {useMemo} from "react"
import {generalSettingsService} from "services"
import {YesNo} from "types/common"
import {DailyAttendanceTimeClockTracking, GeneralSettingField} from "types/settings/general-setting"

type UseDailyAttendanceSettingsProps = {
    enabled?: boolean
}

const useDailyAttendanceSettings = (props?: UseDailyAttendanceSettingsProps) => {
    const {enabled = true} = props || {}
    const {data, refetch, isFetching} = useQuery(
        ["makeup-attendance-setting"],
        () =>
            generalSettingsService.getSettings([
                GeneralSettingField.MakeupDocumentAttachment,
                GeneralSettingField.MakeupRemote,
                GeneralSettingField.MakeupDocumentAttachmentMandatory,
                GeneralSettingField.DailyAttendanceTimeClockTracking
            ]),
        {
            initialData: [],
            enabled
        }
    )

    const isMakeupDocumentAttachmentEnabled = useMemo(
        () =>
            data.find((setting) => setting.field === GeneralSettingField.MakeupDocumentAttachment)?.value === YesNo.Yes,
        [data]
    )

    const isRemoteMakeupDocumentEnabled = useMemo(
        () => data.find((setting) => setting.field === GeneralSettingField.MakeupRemote)?.value === YesNo.Yes,
        [data]
    )

    const isMakeupDocumentAttachmentMandatory = useMemo(
        () =>
            data.find((setting) => setting.field === GeneralSettingField.MakeupDocumentAttachmentMandatory)?.value ===
            YesNo.Yes,
        [data]
    )

    const dailyAttendanceTimeClockTracking = useMemo(
        () =>
            data.find((setting) => setting.field === GeneralSettingField.DailyAttendanceTimeClockTracking)
                ?.value as DailyAttendanceTimeClockTracking,
        [data]
    )

    return {
        data,
        isMakeupDocumentAttachmentEnabled,
        isRemoteMakeupDocumentEnabled,
        isMakeupDocumentAttachmentMandatory,
        dailyAttendanceTimeClockTracking,
        refetch,
        isFetching
    }
}

export {useDailyAttendanceSettings}
